/* RunIt promises on the page: keeps the PDP fit line and graphic row in step with the selected
   variant and personalisation, and sends the promise events through RunItAnalytics (consent-gated,
   personal data scrubbed). Eligibility itself is decided in snippets/runit-promise.liquid; this only
   picks which of the server-rendered states to show. */
(function () {
  'use strict';

  // Which fit state and whether the graphic row shows, for a variant map entry and personalisation.
  // entry: { fit, print, pz } from the page's variant map (pz = covered once personalised).
  function stateFor(entry, pz, fallbackFit) {
    var fit = pz ? 'personalised' : (entry ? entry.fit : fallbackFit);
    if (entry && entry.fit === 'none') fit = 'none';
    var print = !!(entry && (pz ? entry.pz : entry.print));
    return { fit: fit, print: print };
  }
  window.rlPromise = { stateFor: stateFor };
  if (typeof document === 'undefined') return;

  var current = { variant: null, pz: false };

  function readMap() {
    var el = document.querySelector('[data-promise-map]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function apply() {
    var map = readMap();
    if (!map) return;
    var entry = current.variant ? map[current.variant] : null;
    document.querySelectorAll('[data-promise-fit]').forEach(function (root) {
      if (!root.dataset.initialFit) {
        var shown = root.querySelector('[data-fit-state]:not([hidden])');
        root.dataset.initialFit = shown ? shown.dataset.fitState : 'none';
      }
      var s = stateFor(entry, current.pz, root.dataset.initialFit);
      var has = false;
      root.querySelectorAll('[data-fit-state]').forEach(function (span) {
        span.hidden = span.dataset.fitState !== s.fit;
        if (!span.hidden) has = true;
      });
      root.hidden = !has;
    });
    if (!entry) return; // keep the server-rendered row until the selected variant is known
    document.querySelectorAll('[data-promise-print]').forEach(function (row) {
      row.hidden = !stateFor(entry, current.pz, null).print;
    });
  }

  // The selected variant is the main product form's id input; follow it the way the personaliser does
  // (assets/runit-personalise.js): on picker changes, again after the theme swaps the id, and on pub/sub.
  function follow() {
    var root = document.querySelector('[data-promise-root]');
    var scope = (root && root.closest('product-info, .shopify-section')) || document;
    var input = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!input || !input.value || input.value === current.variant) return;
    current.variant = String(input.value);
    apply();
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios, [data-runit-print-finish], [data-runit-size-option]')) {
      setTimeout(follow, 0); setTimeout(follow, 400);
    }
  });
  document.addEventListener('runit:variant-change', function () { setTimeout(follow, 0); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(follow, 0); });
  }
  document.addEventListener('runit:personalise', function (e) {
    current.pz = !!(e.detail && e.detail.on);
    apply();
  });

  // --- analytics: no names, emails, order numbers or free text, only surface/promise/version ---
  function props(el, attr) {
    var parts = (el.getAttribute(attr) || '').split(':');
    var versioned = el.closest('[data-promise-version]');
    return {
      surface: parts[0] || '',
      promise: parts[1] || '',
      version: (versioned && versioned.getAttribute('data-promise-version')) || ''
    };
  }
  function capture(name, p, dedupe) {
    if (window.RunItAnalytics) window.RunItAnalytics.capture(name, p, dedupe);
  }

  // promise_viewed: once per surface+promise per page, however often the bag re-renders. "Seen" is half the
  // element on screen, or (for a block taller than the screen) 40% of the screen filled by it.
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      if (en.intersectionRatio < 0.5 && en.intersectionRect.height < window.innerHeight * 0.4) return;
      if (window.__runitPosthogLoaded !== true) return; // re-observed on runit:posthog-ready
      var p = props(en.target, 'data-promise-track');
      capture('promise_viewed', p, 'promise_viewed:' + p.surface + ':' + p.promise);
      io.unobserve(en.target);
    });
  }, { threshold: [0, 0.25, 0.5, 0.75, 1] }) : null;
  function watch() {
    if (!io) return;
    document.querySelectorAll('[data-promise-track]:not([data-promise-watched])').forEach(function (el) {
      el.setAttribute('data-promise-watched', '');
      io.observe(el);
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-promise-details]');
    if (a) capture('promise_details_opened', props(a, 'data-promise-details'));
  });

  // Problem-report form: started on first interaction, submitted when Shopify comes back with success.
  // The category is carried across the post in sessionStorage so the success event can say which kind.
  function claimForm() {
    var form = document.getElementById('RunItClaimForm');
    if (!form) return;
    var issue = form.querySelector('[data-claim-issue]');
    form.addEventListener('focusin', function () {
      capture('claim_started', { surface: 'page' }, 'claim_started'); // deduped once sent
    });
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem('rl-claim-issue', issue ? issue.value : ''); } catch (e) {}
    });
    var ok = form.querySelector('[data-claim-success]');
    var status = ok || form.querySelector('[data-claim-error]');
    if (status) {
      status.focus();
      status.scrollIntoView({ block: 'center' });
    }
    if (ok) onAnalytics(function () {
      var kind = null;
      try { kind = sessionStorage.getItem('rl-claim-issue'); sessionStorage.removeItem('rl-claim-issue'); } catch (e) {}
      // Without the stored category this is a reload of the success page: don't count it twice.
      if (kind !== null) capture('claim_submitted', { surface: 'page', issue: kind });
    });
  }

  // Run fn once PostHog has loaded (consent given), now or when runit:posthog-ready fires.
  function onAnalytics(fn) {
    if (window.__runitPosthogLoaded === true) fn();
    else document.addEventListener('runit:posthog-ready', fn, { once: true });
  }

  function start() {
    follow();
    watch();
    onAnalytics(function () {
      // Anything already on screen before consent: look again now PostHog is there.
      document.querySelectorAll('[data-promise-watched]').forEach(function (el) {
        if (io) { io.unobserve(el); io.observe(el); }
      });
    });
    claimForm();
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(watch, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
